var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"600"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_c('p',{staticClass:"alert-text"},[_vm._v(_vm._s(_vm.message))])]),_c('v-card-actions',[_c('mf-action-buttons',{staticClass:"mr-2 pt-2",attrs:{"primary-button":{
          text: 'Fechar',
          action: function () { return (_vm.open = false); },
          isVisible: true,
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }